import sensors from './sensors/sensorsdata.es6.min.js'
import util from './util'
import router from '@/routes/index'
import nativeHybrid from '@/util/nativeHybrid'

let serverUrl = 'https://sensors.nio.com/sa?project=nioapp_test'

let showLog = true

// 用户信息
let userInfo = nativeHybrid.getUserInfo()
let account_id = userInfo.account_id || ''

console.log('%c[AOLIN]', 'color:#3b92de', 'account_id', account_id)

if (util.getEnv() === 3) {
	serverUrl = 'https://sensors.nio.com/sa?project=nioapp_prod'
	showLog = false
}

const params = {
	sdk_url: './sensorsdata.min.js',
	heatmap_url: './heatmap.min.js',
	server_url: serverUrl,
	name: 'sensors',
	app_js_bridge: true,
	show_log: showLog
}

sensors.init(params)

sensors.registerPage({
	platform_type: 'JavaScript'
})
sensors.login(account_id)

const trackFn = sensors.track
sensors.track = function(...args) {
	if (typeof args[1] === 'object') {
		// 这里仅用于埋点验证,所以只填写最近一次需求id即可
		args[1].requirement_id = args[1].requirement_id ? args[1].requirement_id : 2018
		args[1].store = 'PT004'
	}

	if (util.isInWebview()) {
		trackFn(...args)

		// console.log("%c[AOLIN]", "color:#3b92de", '埋点', ...args);
	} else {
		console.log('%c[AOLIN]', 'color:#3b92de', '埋点', ...args)
	}
}

// 此处用于处理页面持续时间的事件统计
let pageId
let ticker

const SAVED_HEARTBEAT = 'savedHeartbeat'

function startTicker() {
	pageId = 'page' + Date.now()

	initHeartbeatData(pageId)

	ticker = setInterval(() => {
		countHeartbeatData(pageId)
	}, 5000)
}

function initHeartbeatData(key) {
	const savedHeartbeat = {
		[key]: {
			startTime: Date.now() - 1000,
			lastTime: Date.now(),
			page: router.currentRoute.name
		}
	}
	if (!localStorage.getItem(SAVED_HEARTBEAT)) {
		localStorage.setItem(SAVED_HEARTBEAT, JSON.stringify(savedHeartbeat))
	} else {
		const obj = JSON.parse(localStorage.getItem(SAVED_HEARTBEAT))

		localStorage.setItem(
			SAVED_HEARTBEAT,
			JSON.stringify({
				...obj,
				...savedHeartbeat
			})
		)
	}
}

function countHeartbeatData(key) {
	const obj = JSON.parse(localStorage.getItem(SAVED_HEARTBEAT))
	if (obj && obj[key]) {
		const savedData = obj[key]

		savedData.lastTime = Date.now()

		localStorage.setItem(SAVED_HEARTBEAT, JSON.stringify(obj))
	}
}

export function setPageLeaveParams(params) {
	const obj = JSON.parse(localStorage.getItem(SAVED_HEARTBEAT))

	if (obj[pageId]) {
		obj[pageId].customParams = params
	}
	localStorage.setItem(SAVED_HEARTBEAT, JSON.stringify(obj))
}

function trackPageLeave(heartbeatData, ms) {
	const pageNames = {
		carhome: {
			name: '二手车商城'
		},
		detail: {
			name: '二手车车辆详情页'
		}
	}

	let duration = Math.ceil(ms / 1000)

	// 大于5000秒的持续时间视为异常数据
	if (duration > 5000) {
		duration = 5000
	}

	const page = pageNames[heartbeatData.page]

	if (page) {
		if (heartbeatData.page === 'carhome') {
			sensors.track('PageInDuration', {
				page: page.name,
				page_duration: duration,
				page_source: router.currentRoute.query.page_source,
				requirement_id: 2015,
				track_sign: 'aMall.b30.exposure.PageInDuration'
			})
		}
		if (heartbeatData.page === 'detail') {
			sensors.track('VehicleDetailPageInDuration', {
				page: page.name,
				page_duration: duration,
				page_source: router.currentRoute.query.page_source,
				label_name: sessionStorage.getItem('trackLabelName'),
				tag: sessionStorage.getItem('trackTags'),
				track_sign: 'aMall.b4307.pageViewTime.VehicleDetailPageInDuration',
				requirement_id: 2018
			})
		}
	}
}

setTimeout(() => {
	// 发出上次数据
	const obj = JSON.parse(localStorage.getItem(SAVED_HEARTBEAT))

	for (let key in obj) {
		if (obj.hasOwnProperty(key)) {
			const heartbeatData = obj[key]
			trackPageLeave(heartbeatData, heartbeatData.lastTime - heartbeatData.startTime)
		}
	}
	localStorage.setItem(SAVED_HEARTBEAT, JSON.stringify({}))

	startTicker()
}, 1000)

document.addEventListener('visibilitychange', e => {
	let hiddenProperty =
		'hidden' in document
			? 'hidden'
			: 'webkitHidden' in document
			? 'webkitHidden'
			: 'mozHidden' in document
			? 'mozHidden'
			: null

	const hidden = document[hiddenProperty]

	if (hidden) {
		// 页面隐藏对页面进行时间上报
		const obj = JSON.parse(localStorage.getItem(SAVED_HEARTBEAT))

		const heartbeatData = obj && obj[pageId]
		if (heartbeatData) {
			trackPageLeave(heartbeatData, Date.now() - heartbeatData.startTime)
		}
		localStorage.setItem(SAVED_HEARTBEAT, JSON.stringify({}))
		clearInterval(ticker)
	} else {
		setTimeout(() => {
			startTicker()
		}, 1000)
	}
})

export default sensors
